import i18n from '@/plugins/i18n';

export default {
  DEV_ENV_1: 'testing',
  DEV_ENV_2: 'testing-2',
  PROD: 'production',
  segmentTypeDefault: [
    {
      id: 1,
      text: '全体',
      textLang: {
        ja: i18n.t('survey_project.select_segment.all', 'ja'),
        en: i18n.t('survey_project.select_segment.all', 'en'),
        cn: i18n.t('survey_project.select_segment.all', 'cn'),
      },
      textDisplay: '全体',
      textTable: '全',
      class: 'segAll',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 2,
      text: '男性',
      textLang: {
        ja: i18n.t('survey_project.select_segment.men', 'ja'),
        en: i18n.t('survey_project.select_segment.men', 'en'),
        cn: i18n.t('survey_project.select_segment.men', 'cn'),
      },
      textDisplay: '男性',
      textTable: '男',
      class: 'segMale',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 3,
      text: '女性',
      textLang: {
        ja: i18n.t('survey_project.select_segment.women', 'ja'),
        en: i18n.t('survey_project.select_segment.women', 'en'),
        cn: i18n.t('survey_project.select_segment.women', 'cn'),
      },
      textDisplay: '女性',
      textTable: '女',
      class: 'segFemale',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 4,
      text: 'カテゴリーユーザー',
      textLang: {
        ja: i18n.t('survey_project.select_segment.customer', 'ja'),
        en: i18n.t('survey_project.select_segment.customer', 'en'),
        cn: i18n.t('survey_project.select_segment.customer', 'cn'),
      },
      textDisplay: 'カテゴリ',
      textTable: 'カテ',
      class: 'segCate',
      isDisplay: false,
      isDisplayFilter: false,
    },
  ],
  segmentTypeAge: [
    {
      id: 5,
      text: '20代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.age_20', 'ja'),
        en: i18n.t('survey_project.select_segment.age_20', 'en'),
        cn: i18n.t('survey_project.select_segment.age_20', 'cn'),
      },
      textDisplay: '20代',
      textTable: '20',
      class: 'age20',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 6,
      text: '30代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.age_30', 'ja'),
        en: i18n.t('survey_project.select_segment.age_30', 'en'),
        cn: i18n.t('survey_project.select_segment.age_30', 'cn'),
      },
      textDisplay: '30代',
      textTable: '30',
      class: 'age30',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 7,
      text: '40代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.age_40', 'ja'),
        en: i18n.t('survey_project.select_segment.age_40', 'en'),
        cn: i18n.t('survey_project.select_segment.age_40', 'cn'),
      },
      textDisplay: '40代',
      textTable: '40',
      class: 'age40',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 8,
      text: '50代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.age_50', 'ja'),
        en: i18n.t('survey_project.select_segment.age_50', 'en'),
        cn: i18n.t('survey_project.select_segment.age_50', 'cn'),
      },
      textDisplay: '50代',
      textTable: '50',
      class: 'age50',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 9,
      text: '年代計',
      textLang: {
        ja: i18n.t('survey_project.select_segment.chronology', 'ja'),
        en: i18n.t('survey_project.select_segment.chronology', 'en'),
        cn: i18n.t('survey_project.select_segment.chronology', 'cn'),
      },
      textDisplay: '',
      textTable: '',
      class: '',
      isDisplay: true,
      isDisplayFilter: false,
    },
  ],
  segmentMix: [
    {
      id: 25,
      text: '男性20代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.all_men_20', 'ja'),
        en: i18n.t('survey_project.select_segment.all_men_20', 'en'),
        cn: i18n.t('survey_project.select_segment.all_men_20', 'cn'),
      },
      textDisplay: '男性20代',
      textTable: '男20',
      class: 'male20',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 26,
      text: '男性30代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.all_men_30', 'ja'),
        en: i18n.t('survey_project.select_segment.all_men_30', 'en'),
        cn: i18n.t('survey_project.select_segment.all_men_30', 'cn'),
      },
      textDisplay: '男性30代',
      textTable: '男30',
      class: 'male30',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 27,
      text: '男性40代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.all_men_40', 'ja'),
        en: i18n.t('survey_project.select_segment.all_men_40', 'en'),
        cn: i18n.t('survey_project.select_segment.all_men_40', 'cn'),
      },
      textDisplay: '男性40代',
      textTable: '男40',
      class: 'male40',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 28,
      text: '男性50代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.all_men_50', 'ja'),
        en: i18n.t('survey_project.select_segment.all_men_50', 'en'),
        cn: i18n.t('survey_project.select_segment.all_men_50', 'cn'),
      },
      textDisplay: '男性50代',
      textTable: '男50',
      class: 'male50',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 35,
      text: '女性20代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.all_women_20', 'ja'),
        en: i18n.t('survey_project.select_segment.all_women_20', 'en'),
        cn: i18n.t('survey_project.select_segment.all_women_20', 'cn'),
      },
      textDisplay: '女性20代',
      textTable: '女20',
      class: 'female20',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 36,
      text: '女性30代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.all_women_30', 'ja'),
        en: i18n.t('survey_project.select_segment.all_women_30', 'en'),
        cn: i18n.t('survey_project.select_segment.all_women_30', 'cn'),
      },
      textDisplay: '女性30代',
      textTable: '女30',
      class: 'female30',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 37,
      text: '女性40代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.all_women_40', 'ja'),
        en: i18n.t('survey_project.select_segment.all_women_40', 'en'),
        cn: i18n.t('survey_project.select_segment.all_women_40', 'cn'),
      },
      textDisplay: '女性40代',
      textTable: '女40',
      class: 'female40',
      isDisplay: true,
      isDisplayFilter: true,
    },
    {
      id: 38,
      text: '女性50代',
      textLang: {
        ja: i18n.t('survey_project.select_segment.all_women_50', 'ja'),
        en: i18n.t('survey_project.select_segment.all_women_50', 'en'),
        cn: i18n.t('survey_project.select_segment.all_women_50', 'cn'),
      },
      textDisplay: '女性50代',
      textTable: '女50',
      class: 'female50',
      isDisplay: true,
      isDisplayFilter: true,
    },
  ],
  // Concept valuation uses the same segment ids as survey (SEGMENT_LIST).

  TYPE_SEGMENT_AVG: 1,
  TYPE_SEGMENT_INDIVIDUAL: 0,

  menu: [
    {
      id: 1,
      text: '好意度予測スコア',
      textLang: {
        ja: i18n.t('survey_project.select_menu.likelihood_prediction_score', 'ja'),
        en: i18n.t('survey_project.select_menu.likelihood_prediction_score', 'en'),
        cn: i18n.t('survey_project.select_menu.likelihood_prediction_score', 'cn'),
      },
      textResult: '好意度予測スコア結果',
      textResultLanguage: {
        ja: i18n.t('survey_project.select_menu_result.likelihood_prediction_score', 'ja'),
        en: i18n.t('survey_project.select_menu_result.likelihood_prediction_score', 'en'),
        cn: i18n.t('survey_project.select_menu_result.likelihood_prediction_score', 'cn'),
      },
      required: false,
      class: '#scoreBlock',
      class_collapse: 'collapse_score',
      active: 'active',
      help: 'パッケージデザインの好意度スコアを最大5（好き）から最小1（好きではない）までの加重平均値で予測します。全体のほかにも男性・女性、年代別、性別×年代ごとに算出することができます。',
      helpLanguage: {
        ja: i18n.t('survey_project.select_menu.help.prediction_score', 'ja'),
        en: i18n.t('survey_project.select_menu.help.prediction_score', 'en'),
        cn: i18n.t('survey_project.select_menu.help.prediction_score', 'cn'),
      },
      notice: false,
    },
    {
      id: 2,
      text: 'ヒートマップ',
      textLang: {
        ja: i18n.t('survey_project.select_menu.heat_map', 'ja'),
        en: i18n.t('survey_project.select_menu.heat_map', 'en'),
        cn: i18n.t('survey_project.select_menu.heat_map', 'cn'),
      },
      textResult: 'ヒートマップ結果',
      textResultLanguage: {
        ja: i18n.t('survey_project.select_menu_result.heat_map', 'ja'),
        en: i18n.t('survey_project.select_menu_result.heat_map', 'en'),
        cn: i18n.t('survey_project.select_menu_result.heat_map', 'cn'),
      },
      required: true,
      class: '#heatmapBlock',
      class_collapse: 'collapse_hm',
      active: 'active',
      help: '好意度を予測するうえで作り出す特徴量マップをベースに、注視している箇所ほど赤く、そうでない箇所ほど青くなるようにヒートマップ形式で可視化しています。パッケージデザインを修正する参考になります。',
      helpLanguage: {
        ja: i18n.t('survey_project.select_menu.help.heat_map', 'ja'),
        en: i18n.t('survey_project.select_menu.help.heat_map', 'en'),
        cn: i18n.t('survey_project.select_menu.help.heat_map', 'cn'),
      },
      notice: true,
    },
    {
      id: 3,
      text: 'イメージワード',
      textLang: {
        ja: i18n.t('survey_project.select_menu.image_word', 'ja'),
        en: i18n.t('survey_project.select_menu.image_word', 'en'),
        cn: i18n.t('survey_project.select_menu.image_word', 'cn'),
      },
      textResult: 'イメージワード結果',
      textResultLanguage: {
        ja: i18n.t('survey_project.select_menu_result.image_word', 'ja'),
        en: i18n.t('survey_project.select_menu_result.image_word', 'en'),
        cn: i18n.t('survey_project.select_menu_result.image_word', 'cn'),
      },
      required: false,
      class: '#imagewordBlock',
      class_collapse: 'collapse_wd',
      active: 'active',
      help: '好意度の理由を19（非飲食系は18）の',
      help2: 'の出現割合で予測することができます。膨大な自由回答から自然言語処理技術を駆使して構築しています。',
      helpLanguage: {
        ja: i18n.t('survey_project.select_menu.help.image_word_1', 'ja'),
        en: i18n.t('survey_project.select_menu.help.image_word_1', 'en'),
        cn: i18n.t('survey_project.select_menu.help.image_word_1', 'cn'),
      },
      help2Language: {
        ja: i18n.t('survey_project.select_menu.help.image_word_2', 'ja'),
        en: i18n.t('survey_project.select_menu.help.image_word_2', 'en'),
        cn: i18n.t('survey_project.select_menu.help.image_word_2', 'cn'),
      },
      notice: false,
    },
    {
      id: 4,
      text: '好意度のバラつき',
      textLang: {
        ja: i18n.t('survey_project.select_menu.variation_in_favorability', 'ja'),
        en: i18n.t('survey_project.select_menu.variation_in_favorability', 'en'),
        cn: i18n.t('survey_project.select_menu.variation_in_favorability', 'cn'),
      },
      textResult: '好意度のバラつき結果',
      textResultLanguage: {
        ja: i18n.t('survey_project.select_menu_result.variation_in_favorability', 'ja'),
        en: i18n.t('survey_project.select_menu_result.variation_in_favorability', 'en'),
        cn: i18n.t('survey_project.select_menu_result.variation_in_favorability', 'cn'),
      },
      required: false,
      class: '#varianceBlock',
      class_collapse: 'collapse_variance',
      active: 'active',
      help: '好意度の標準偏差（どの程度バラついているか）を予測します。この数値が高いほどバラつきが大きいと考えられますので、そのデザインの好き嫌いの差が大きいと解釈できます。',
      helpLanguage: {
        ja: i18n.t('survey_project.select_menu.help.variation_in_favorability', 'ja'),
        en: i18n.t('survey_project.select_menu.help.variation_in_favorability', 'en'),
        cn: i18n.t('survey_project.select_menu.help.variation_in_favorability', 'cn'),
      },
      notice: false,
    },
    {
      id: 13,
      text: 'コンセプト合致度',
      textLang: {
        ja: i18n.t('survey_project.select_menu.concept_matching', 'ja'),
        en: i18n.t('survey_project.select_menu.concept_matching', 'en'),
        cn: i18n.t('survey_project.select_menu.concept_matching', 'cn'),
      },
      textResult: 'コンセプト合致度',
      textResultLanguage: {
        ja: i18n.t('survey_project.select_menu_result.concept_matching', 'ja'),
        en: i18n.t('survey_project.select_menu_result.concept_matching', 'en'),
        cn: i18n.t('survey_project.select_menu_result.concept_matching', 'cn'),
      },
      required: false,
      class: '',
      class_collapse: '',
      active: 'active',
      help: '',
      helpLanguage: {
        ja: i18n.t('survey_project.select_menu.help.concept_matching', 'ja'),
        en: i18n.t('survey_project.select_menu.help.concept_matching', 'en'),
        cn: i18n.t('survey_project.select_menu.help.concept_matching', 'cn'),
      },
      notice: false,
    },
    {
      id: 14,
      text: '類似画像検索',
      textLang: {
        ja: i18n.t('survey_project.select_menu.similarity_level', 'ja'),
        en: i18n.t('survey_project.select_menu.similarity_level', 'en'),
        cn: i18n.t('survey_project.select_menu.similarity_level', 'cn'),
      },
      textResult: '類似画像検索',
      textResultLanguage: {
        ja: i18n.t('survey_project.select_menu_result.similarity_level', 'ja'),
        en: i18n.t('survey_project.select_menu_result.similarity_level', 'en'),
        cn: i18n.t('survey_project.select_menu_result.similarity_level', 'cn'),
      },
      required: false,
      class: '',
      class_collapse: '',
      active: 'active',
      help: '',
      helpLanguage: {
        ja: i18n.t('survey_project.select_menu.help.similarity_level', 'ja'),
        en: i18n.t('survey_project.select_menu.help.similarity_level', 'en'),
        cn: i18n.t('survey_project.select_menu.help.similarity_level', 'cn'),
      },
      notice: false,
    },
  ],
  GENERATE_CONCEPT_TREND: 1,
  GENERATE_CONCEPT_NEEDS: 2,
  GENERATE_CONCEPT_NEW_USAGE: 3,
  GENERATE_CONCEPT_TECHNOLOGY: 4,
  GENERATE_CONCEPT_BRAND_FUTURE: 5,

  EDIT_CONCEPT_TYPE_DETAIL: 1,
  EDIT_CONCEPT_TYPE_VARIATION: 2,
  EDIT_CONCEPT_TYPE_BRUSH_UP: 3,
  EDIT_CONCEPT_TYPE_COMPANY_UNIQUE: 4,
  EDIT_CONCEPT_TYPE_COMPANY_CONCEPT_RULE: 5,
  EDIT_CONCEPT_TYPE_FREE_TEXT: 6,

  MENU_GENERATE_CONCEPT: [
    {
      id: 1,
      code: 'TRENDS',
      text: 'トレンドから',
      textLang: {
        ja: i18n.t('generate_concept_menu.select_menu.trend', 'ja'),
        en: i18n.t('generate_concept_menu.select_menu.trend', 'en'),
        cn: i18n.t('generate_concept_menu.select_menu.trend', 'cn'),
      },
      required: false,
    },
    {
      id: 2,
      code: 'NEEDS',
      text: 'ニーズから',
      textLang: {
        ja: i18n.t('generate_concept_menu.select_menu.needs', 'ja'),
        en: i18n.t('generate_concept_menu.select_menu.needs', 'en'),
        cn: i18n.t('generate_concept_menu.select_menu.needs', 'cn'),
      },
      required: false,
    },
    {
      id: 3,
      code: 'NEW_USAGE',
      text: '新しい使い方から',
      textLang: {
        ja: i18n.t('generate_concept_menu.select_menu.newUsage', 'ja'),
        en: i18n.t('generate_concept_menu.select_menu.newUsage', 'en'),
        cn: i18n.t('generate_concept_menu.select_menu.newUsage', 'cn'),
      },
      required: false,
    },
    {
      id: 4,
      code: 'TECHNOLOGY',
      text: '技術から',
      textLang: {
        ja: i18n.t('generate_concept_menu.select_menu.technology', 'ja'),
        en: i18n.t('generate_concept_menu.select_menu.technology', 'en'),
        cn: i18n.t('generate_concept_menu.select_menu.technology', 'cn'),
      },
      required: false,
    },
    {
      id: 5,
      code: 'BRAND_FUTURE',
      text: 'ブランドの未来',
      textLang: {
        ja: i18n.t('generate_concept_menu.select_menu.brand_future', 'ja'),
        en: i18n.t('generate_concept_menu.select_menu.brand_future', 'en'),
        cn: i18n.t('generate_concept_menu.select_menu.brand_future', 'cn'),
      },
      required: false,
    },
  ],
  /** Max poster (prompt assist) opens per session for generate free plan users. */
  GENERATE_CONCEPT_FREE_PLAN_POSTER_MAX_USES: 5,
  CONCEPT_TECHNOLOGY_KEYWORDS_TYPE: {
    1: '親和性あり',
    2: '親和性なし',
  },
  PLAN_TYPE_ADHOC: 2,
  PLAN_TYPE_FREE: 3,
  PLAN_TYPE_TRIAL: 4,
  PLAN_TYPE_BY_MONTH: 1,
  PLAN_TYPE_NOT_FEE: [3, 4],
  PLAN_TYPE_NOT_EXPIRED: [2, 3, 4],
  PLAN_TRIAL_ID: 7,

  MENU_FOR_FREE: 1,
  MENU_FOR_OVER_ALL: 1,
  MENU_FOR_HEAT_MAP: 2,
  MENU_FOR_IMAGEWORD: 3,
  MENU_FOR_VARIANCE: 4,
  MENU_FOR_AUTO_CREATE: 5,
  MENU_FOR_AUTO_CREATE_LOGO: 6,
  REPORT_ALL: 7,
  MENU_FOR_HEATMAP_SHELVE: 8,
  MENU_FOR_CHAT_GPT: 9,
  // GENERATE_IMAGE: 10
  // GENERATE_KEY_VISUAL: 11
  // GENERATE_CONCEPT: 12
  MENU_FOR_CONCEPT_MATCHING: 13,
  MENU_FOR_SIMILARITY_LEVEL: 14,
  MENU_FOR_CONCEPT_VALUATION_USAGE: 15,
  MENU_FOR_CONCEPT_VALUATION_ATTRACTIVE: 16,


  SIMILARITY_TASK_PLUG_DATABASE: 1,
  SIMILARITY_TASK_CALCULATE_SIMILARITY: 2,
  TASK_CALCULATE_SIMILARITY_MAX_IMAGE: 2,

  SIMILARITY_JOB_STATUS_SUCCESS: 'SUCCESS',
  SIMILARITY_JOB_STATUS_FAILED: 'FAILED',
  SIMILARITY_JOB_STATUS_TIMEOUT: 'TIMEOUT',
  SIMILARITY_JOB_STATUS_PENDING: "PENDING",
  SIMILARITY_JOB_STATUS_RUNNING: "RUNNING",

  CELERY_JOB_STATUS_FAILED: 'FAILED',
  CELERY_JOB_STATUS_TIMEOUT: 'TIMEOUT',

  TEXT_REPORT_ALL: '一括レポート',
  TEXT_MENU_ALL: 'すべて',
  SEGMENT_OVERALL: 1,
  SEGMENT_EVERY_AGE: 9,
  CATEGORYOTHER: 27,
  NEW_PROJECT: 1,
  STEP_SELECT_IMAGE: 4,
  STEP_SELECT_PRODUCT_COPY: 5,
  STEP_SELECT_CATEGORY: 6,
  STEP_SELECT_CONFIRM: 7,
  drinkFlagList: [
    {
      id: 1,
      text: '飲食系',
    },
    {
      id: 2,
      text: '非飲食系',
    },
  ],
  listWordInTable: [
    {
      id: 1,
      name: 'おいしそう',
      nameLanguage: {
        ja: i18n.t('listWordInTable.1', 'ja'),
        en: i18n.t('listWordInTable.1', 'en'),
        cn: i18n.t('listWordInTable.1', 'cn'),
      },
    },
    {
      id: 2,
      name: i18n.t('listWordInTable.2'),
      nameLanguage: {
        ja: i18n.t('listWordInTable.2', 'ja'),
        en: i18n.t('listWordInTable.2', 'en'),
        cn: i18n.t('listWordInTable.2', 'cn'),
      },
    },
    {
      id: 3,
      name: 'かわいい',
      nameLanguage: {
        ja: i18n.t('listWordInTable.3', 'ja'),
        en: i18n.t('listWordInTable.3', 'en'),
        cn: i18n.t('listWordInTable.3', 'cn'),
      },
    },
    {
      id: 4,
      name: 'シンプル',
      nameLanguage: {
        ja: i18n.t('listWordInTable.4', 'ja'),
        en: i18n.t('listWordInTable.4', 'en'),
        cn: i18n.t('listWordInTable.4', 'cn'),
      },
    },
    {
      id: 5,
      name: 'なつかしい',
      nameLanguage: {
        ja: i18n.t('listWordInTable.5', 'ja'),
        en: i18n.t('listWordInTable.5', 'en'),
        cn: i18n.t('listWordInTable.5', 'cn'),
      },
    },
    {
      id: 6,
      name: 'やさしい',
      nameLanguage: {
        ja: i18n.t('listWordInTable.6', 'ja'),
        en: i18n.t('listWordInTable.6', 'en'),
        cn: i18n.t('listWordInTable.6', 'cn'),
      },
    },
    {
      id: 7,
      name: '安心感・信頼感がある',
      nameLanguage: {
        ja: i18n.t('listWordInTable.7', 'ja'),
        en: i18n.t('listWordInTable.7', 'en'),
        cn: i18n.t('listWordInTable.7', 'cn'),
      },
    },
    {
      id: 8,
      name: '季節感',
      nameLanguage: {
        ja: i18n.t('listWordInTable.8', 'ja'),
        en: i18n.t('listWordInTable.8', 'en'),
        cn: i18n.t('listWordInTable.8', 'cn'),
      },
    },
    {
      id: 9,
      name: '健康感がある',
      nameLanguage: {
        ja: i18n.t('listWordInTable.9', 'ja'),
        en: i18n.t('listWordInTable.9', 'en'),
        cn: i18n.t('listWordInTable.9', 'cn'),
      },
    },
    {
      id: 10,
      name: '効果・効能を感じる',
      nameLanguage: {
        ja: i18n.t('listWordInTable.10', 'ja'),
        en: i18n.t('listWordInTable.10', 'en'),
        cn: i18n.t('listWordInTable.10', 'cn'),
      },
    },
    {
      id: 11,
      name: '高級感・上質感',
      nameLanguage: {
        ja: i18n.t('listWordInTable.11', 'ja'),
        en: i18n.t('listWordInTable.11', 'en'),
        cn: i18n.t('listWordInTable.11', 'cn'),
      },
    },
    {
      id: 12,
      name: '色味がよい',
      nameLanguage: {
        ja: i18n.t('listWordInTable.12', 'ja'),
        en: i18n.t('listWordInTable.12', 'en'),
        cn: i18n.t('listWordInTable.12', 'cn'),
      },
    },
    {
      id: 13,
      name: '新しい・ユニーク',
      nameLanguage: {
        ja: i18n.t('listWordInTable.13', 'ja'),
        en: i18n.t('listWordInTable.13', 'en'),
        cn: i18n.t('listWordInTable.13', 'cn'),
      },
    },
    {
      id: 14,
      name: '洗練',
      nameLanguage: {
        ja: i18n.t('listWordInTable.14', 'ja'),
        en: i18n.t('listWordInTable.14', 'en'),
        cn: i18n.t('listWordInTable.14', 'cn'),
      },
    },
    {
      id: 15,
      name: '爽やか・清涼感',
      nameLanguage: {
        ja: i18n.t('listWordInTable.15', 'ja'),
        en: i18n.t('listWordInTable.15', 'en'),
        cn: i18n.t('listWordInTable.15', 'cn'),
      },
    },
    {
      id: 16,
      name: '特徴がわかりやすい',
      nameLanguage: {
        ja: i18n.t('listWordInTable.16', 'ja'),
        en: i18n.t('listWordInTable.16', 'en'),
        cn: i18n.t('listWordInTable.16', 'cn'),
      },
    },
    {
      id: 17,
      name: '目立つ・印象に残る',
      nameLanguage: {
        ja: i18n.t('listWordInTable.17', 'ja'),
        en: i18n.t('listWordInTable.17', 'en'),
        cn: i18n.t('listWordInTable.17', 'cn'),
      },
    },
    {
      id: 18,
      name: '綺麗・美しい',
      nameLanguage: {
        ja: i18n.t('listWordInTable.18', 'ja'),
        en: i18n.t('listWordInTable.18', 'en'),
        cn: i18n.t('listWordInTable.18', 'cn'),
      },
    },
    {
      id: 19,
      name: '清潔',
      nameLanguage: {
        ja: i18n.t('listWordInTable.19', 'ja'),
        en: i18n.t('listWordInTable.19', 'en'),
        cn: i18n.t('listWordInTable.19', 'cn'),
      },
    },
    {
      id: 20,
      name: 'ファッショナブル',
      nameLanguage: {
        ja: i18n.t('listWordInTable.20', 'ja'),
        en: i18n.t('listWordInTable.20', 'en'),
        cn: i18n.t('listWordInTable.20', 'cn'),
      },
    },
  ],
  IS_NEW_PROJECT: 1,
  SEGMENT_CATE_USER: 4,
  CATEGORY_DEFAULT: 1,
  TEXT_DETAULT: 'なし',
  NO_SEGMENT: 0,
  MAX_SEGMENT: 6,
  TOTAL_SEGMENT: 15,

  MAX_USERS_DEFAULT: 100,

  IS_PHASE4: 4,
  IS_PHASE5: 5,
  IS_PHASE8: 8,
  MAX_SELECTED_WORD: 19,
  MAX_SELECTED_WORD_CN: 20,
  ROLE_ADMIN: 1,

  SUPERUSER: 1,
  NON_SUPERUSER: 0,
  MAIL_CC: 1,

  MAX_SIZE_IMAGE: 5 * 1024 * 1024,
  MAX_SIZE_IMAGE_LOGO: 4 * 1024 * 1024,
  MAX_SIZE_HEATMAP: 15 * 1024 * 1024,
  MAX_SIZE_PSD: 25 * 1024 * 1024,
  MAX_SIZE_LORA: 50 * 1024 * 1024,
  MAX_LENGTH_PSD: 5,
  // modal process-create/
  UNIT_PAY_AD_HOC_PLAN: 20000,
  MODAL_PAY_AD_HOC_PLAN: 0,
  // modal auto-create/select-order
  UNIT_PAY_PLUG_REQUEST: 200000,
  MODAL_PAY_PLUG_REQUEST: 2,
  // modal auto-create/select-order 実行①
  UNIT_PAY_PROCESS_1: 300000,
  MODAL_PAY_PROCESS_1: 3,
  // modal auto-create/select-order 実行②
  UNIT_PAY_PROCESS_2: 300000,
  MODAL_PAY_PROCESS_2: 4,
  // modal logo/create
  UNIT_PAY_LOGO_CREATE: 15000,
  MODAL_PAY_LOGO_CREATE: 5,

  UNIT_PAY_SHELVE_CREATE: 20000,
  UNIT_PAY_SHELVE_CREATE_CN: 730,
  UNIT_PAY_SHELVE_CREATE_TH: 3600,
  UNIT_PAY_SHELVE_CREATE_ID: 1560000,
  MODAL_PAY_SHELVE_CREATE: 6,

  MAX_IMG_LOGO: 2,

  USER_TYPE: {
    ACTIVE: 1,
  },
  SEGMENT_TYPE: {
    DEFAULT: 0,
    AGE: 1,
  },
  SEGMENT_LIST: [
    [
      {
        id: 1,
        text: '全体',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all', 'ja'),
          en: i18n.t('survey_project.select_segment.all', 'en'),
          cn: i18n.t('survey_project.select_segment.all', 'cn'),
        },
        background: '#F06400',
      },
      {
        id: 2,
        text: '男性全体',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_men', 'ja'),
          en: i18n.t('survey_project.select_segment.all_men', 'en'),
          cn: i18n.t('survey_project.select_segment.all_men', 'cn'),
        },
        background: '#6496FF',
      },
      {
        id: 3,
        text: '女性全体',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_women', 'ja'),
          en: i18n.t('survey_project.select_segment.all_women', 'en'),
          cn: i18n.t('survey_project.select_segment.all_women', 'cn'),
        },
        background: '#FF647D',
      },
    ],
    [
      {
        id: 5,
        text: '20代全体',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_20', 'ja'),
          en: i18n.t('survey_project.select_segment.all_20', 'en'),
          cn: i18n.t('survey_project.select_segment.all_20', 'cn'),
        },
        background: '#F3E100',
      },
      {
        id: 25,
        text: '男性20代',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_men_20', 'ja'),
          en: i18n.t('survey_project.select_segment.all_men_20', 'en'),
          cn: i18n.t('survey_project.select_segment.all_men_20', 'cn'),
        },
        background: '#37BEF0',
      },
      {
        id: 35,
        text: '女性20代',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_women_20', 'ja'),
          en: i18n.t('survey_project.select_segment.all_women_20', 'en'),
          cn: i18n.t('survey_project.select_segment.all_women_20', 'cn'),
        },
        background: '#EE87B4',
      },
    ],
    [
      {
        id: 6,
        text: '30代全体',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_30', 'ja'),
          en: i18n.t('survey_project.select_segment.all_30', 'en'),
          cn: i18n.t('survey_project.select_segment.all_30', 'cn'),
        },
        background: '#F5A200',
      },
      {
        id: 26,
        text: '男性30代',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_men_30', 'ja'),
          en: i18n.t('survey_project.select_segment.all_men_30', 'en'),
          cn: i18n.t('survey_project.select_segment.all_men_30', 'cn'),
        },
        background: '#0080CB',
      },
      {
        id: 36,
        text: '女性30代',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_women_30', 'ja'),
          en: i18n.t('survey_project.select_segment.all_women_30', 'en'),
          cn: i18n.t('survey_project.select_segment.all_women_30', 'cn'),
        },
        background: '#E95389',
      },
    ],
    [
      {
        id: 7,
        text: '40代全体',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_40', 'ja'),
          en: i18n.t('survey_project.select_segment.all_40', 'en'),
          cn: i18n.t('survey_project.select_segment.all_40', 'cn'),
        },
        background: '#E10000',
      },
      {
        id: 27,
        text: '男性40代',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_men_40', 'ja'),
          en: i18n.t('survey_project.select_segment.all_men_40', 'en'),
          cn: i18n.t('survey_project.select_segment.all_men_40', 'cn'),
        },
        background: '#004098',
      },
      {
        id: 37,
        text: '女性40代',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_women_40', 'ja'),
          en: i18n.t('survey_project.select_segment.all_women_40', 'en'),
          cn: i18n.t('survey_project.select_segment.all_women_40', 'cn'),
        },
        background: '#B60081',
      },
    ],
    [
      {
        id: 8,
        text: '女性40代',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_50', 'ja'),
          en: i18n.t('survey_project.select_segment.all_50', 'en'),
          cn: i18n.t('survey_project.select_segment.all_50', 'cn'),
        },
        background: '#BB511F',
      },
      {
        id: 28,
        text: '男性50代',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_men_50', 'ja'),
          en: i18n.t('survey_project.select_segment.all_men_50', 'en'),
          cn: i18n.t('survey_project.select_segment.all_men_50', 'cn'),
        },
        background: '#1F2A66',
      },
      {
        id: 38,
        text: '女性50代',
        textLang: {
          ja: i18n.t('survey_project.select_segment.all_women_50', 'ja'),
          en: i18n.t('survey_project.select_segment.all_women_50', 'en'),
          cn: i18n.t('survey_project.select_segment.all_women_50', 'cn'),
        },
        background: '#6C216D',
      },
    ],
  ],
  COLOR_CHART: [
    '#6496FF',
    '#F06400',
    '#F3E100',
    '#6c2606',
    '#004098',
    '#EE87B4',
    '#E10000',
  ],
  GROUP_CATEGORIES: [
    { group: 'アルコール類', categories: [] },
    { group: '飲料', categories: [] },
    { group: 'デザート類', categories: [] },
    { group: '常温食品', categories: [] },
    { group: '菓子類', categories: [] },
    { group: '化粧品', categories: [] },
    { group: '医薬品', categories: [] },
    { group: '衛生用品', categories: [] },
    { group: 'ペット', categories: [] },
  ],
  BLUR_LIST: [
    { id: 10, text: '0～10ピクセル' },
    { id: 50, text: '11～50ピクセル' },
    { id: 100, text: '51～100ピクセル' },
  ],
  TYPES_LAYER: [
    { id: 1, text: '可' },
    { id: 2, text: '不可' },
  ],
  MAX_IMAGES: 10,
  HTTP_OK: 200,
  HTTP_CREATED: 201,
  HTTP_NO_CONTENT: 204,
  HTTP_UNAUTHORIZED: 401,
  HTTP_PERMISSION_DENIED: 403,
  HTTP_NOT_FOUND: 404,
  HTTP_STATUS_CONFLICT: 409,
  // Similarity reference bulk ZIP/CSV: keep in sync with apps/pdr/constant.py and pdrai/settings.py
  SIMILARITY_REFERENCE_MAX_ARCHIVE_BYTES: 1000 * 1024 * 1024,
  SIMILARITY_REFERENCE_MAX_MULTIPART_BODY_BYTES: 2000 * 1024 * 1024,
  HTTP_BAD_REQUEST: 400,
  HTTP_UNPROCESSABLE_ENTITY: 422,
  PROJECT_STATUS_SUCCESS: 'SUCCESS',
  PROJECT_STATUS_PROGRESS: 'PROGRESS',
  PROJECT_STATUS_PENDING: 'PENDING',
  PROJECT_STATUS_FAILURE: 'FAILURE',
  PROJECT_STATUS_CANCEL: 'CANCEL',
  STANDARD_VALUE_NONE: 0,
  STANDARD_VALUE_PLUG: 1,
  STANDARD_VALUE_COMPANY: 2,
  STANDARD_VALUE_USER_SETTING: 3,
  STANDARD_VALUE_OVERALL_FIXED: 4,
  STANDARD_VALUES: [
    {
      value: 1,
      label: 'PLUGデータを使う',
      labelLanguage: {
        ja: i18n.t('use_plug_data', 'ja'),
        en: i18n.t('use_plug_data', 'en'),
        cn: i18n.t('use_plug_data', 'cn'),
      },
    },
    {
      value: 2,
      label: '自社の過去スコアを使う',
      labelLanguage: {
        ja: i18n.t('use_past_data', 'ja'),
        en: i18n.t('use_past_data', 'en'),
        cn: i18n.t('use_past_data', 'cn'),
      },
    },
    {
      value: 3,
      label: '自社の基準値を使う',
      labelLanguage: {
        ja: i18n.t('use_standard_data', 'ja'),
        en: i18n.t('use_standard_data', 'en'),
        cn: i18n.t('use_standard_data', 'cn'),
      },
    },
  ],
  USE_STD_VALUES: [
    {
      value: true,
      label: '基準値を使う',
      labelLanguage: {
        ja: i18n.t('use_std_values_reference', 'ja'),
        en: i18n.t('use_std_values_reference', 'en'),
        cn: i18n.t('use_std_values_reference', 'cn'),
      },
    },
    {
      value: false,
      label: '基準値を使わない',
      labelLanguage: {
        ja: i18n.t('use_std_values_not_reference', 'ja'),
        en: i18n.t('use_std_values_not_reference', 'en'),
        cn: i18n.t('use_std_values_not_reference', 'cn'),
      },
    },
  ],
  COUNT_IMAGE_UPLOAD_REPORT_ALL: 10,
  COUNT_IMAGE_FOR_COMPARE: 2,
  NUMBER_SEGMENT_SHOW_REPORT_ALL: 1,
  CATEGORY_OTHER_VALUE: 55,
  DEFAULT_TITLE: 'PLUGパッケージデザインAI',
  DEFAULT_TITLE_LANG: {
    ja: i18n.t('default_title', 'ja'),
    en: i18n.t('default_title', 'en'),
    cn: i18n.t('default_title', 'cn'),
  },
  WORD_ONLY_FOOD_DRINK: 1,
  FOOD_DRINK: 1,
  NON_FOOD_DRINK: 2,
  DEBOUNCED_TIME: 1000,
  TYPE_PROJECT_SURVEY: 1,
  TYPE_PROJECT_CREATE: 2,
  TYPE_PROJECT_LOGO: 3,
  TYPE_PROJECT_HEATMAP_SHELVE: 4,
  TYPE_PROJECT_CHATGPT: 5,
  TYPE_PROJECT_STABLE_DIFFUSION: 6,
  TYPE_PROJECT_GENERATE_KEY_VISUAL: 7,
  TYPE_PROJECT_GENERATE_CONCEPT: 8,
  TYPE_PROJECT_CONCEPT_VALUATION: 9,
  TYPE_PROJECT_AI_GROUP_INTERVIEW: 10,
  EXPORT_AI_GROUP_INTERVIEW_MODAL_ID: 'exportAiGroupInterviewModal',
  PER_PAGE: [10, 25, 50, 100],
  SEGMENT_TYPES: {
    1: '全体',
    2: '男性\n全体',
    3: '女性\n全体',
    5: '20代',
    6: '30代',
    7: '40代',
    8: '50代',
    25: '男性\n20代',
    26: '男性\n30代',
    27: '男性\n40代',
    28: '男性\n50代',
    35: '女性\n20代',
    36: '女性\n30代',
    37: '女性\n40代',
    38: '女性\n50代',
  },
  SEGMENT_TYPES_EN: {
    1: 'Overall',
    2: 'Male',
    3: 'Female',
    5: '20s',
    6: '30s',
    7: '40s',
    8: '50s',
    25: 'Male\n20s',
    26: 'Male\n30s',
    27: 'Male\n40s',
    28: 'Male\n50s',
    35: 'Female\n20s',
    36: 'Female\n30s',
    37: 'Female\n40s',
    38: 'Female\n50s',
  },
  SEGMENT_TYPES_CN: {
    1: '全体',
    2: '男性\n全体',
    3: '女性\n全体',
    5: '20代',
    6: '30代',
    7: '40代',
    8: '50代',
    25: '男性\n20代',
    26: '男性\n30代',
    27: '男性\n40代',
    28: '男性\n50代',
    35: '女性\n20代',
    36: '女性\n30代',
    37: '女性\n40代',
    38: '女性\n50代',
  },
  COUNTRY_USER_JP: 'jp',
  COUNTRY_USER_CN: 'cn',
  COUNTRY_USER_TH: 'th',
  COUNTRY_USER_ID: 'id',
  COUNTRY_USER_OT: 'ot',
  COUNTRY_USER: [
    {
      key: 'jp',
      value: {
        ja: i18n.t('country_user.ja', 'ja'),
        en: i18n.t('country_user.ja', 'en'),
        cn: i18n.t('country_user.ja', 'cn'),
      },
    },
    {
      key: 'cn',
      value: {
        ja: i18n.t('country_user.cn', 'ja'),
        en: i18n.t('country_user.cn', 'en'),
        cn: i18n.t('country_user.cn', 'cn'),
      },
    },
    {
      key: 'th',
      value: {
        ja: i18n.t('country_user.th', 'ja'),
        en: i18n.t('country_user.th', 'en'),
        cn: i18n.t('country_user.th', 'cn'),
      },
    },
    {
      key: 'id',
      value: {
        ja: i18n.t('country_user.id', 'ja'),
        en: i18n.t('country_user.id', 'en'),
        cn: i18n.t('country_user.id', 'cn'),
      },
    },
    {
      key: 'ot',
      value: {
        ja: i18n.t('country_user.ot', 'ja'),
        en: i18n.t('country_user.ot', 'en'),
        cn: i18n.t('country_user.ot', 'cn'),
      },
    },
  ],
  LANGUAGE_JA: 'ja',
  LANGUAGE_EN: 'en',
  LANGUAGE_CN: 'cn',
  LANGUAGE: [
    {
      title: '日本語',
      key: 'ja',
    },
    {
      title: 'English',
      key: 'en',
    },
    {
      title: '中文简体',
      key: 'cn',
    },
    // {
    //   title: '中文简体',
    //   key: 'cn',
    // },
    // {
    //   title: 'ไทย',
    //   key: 'th',
    // },
    // {
    //   title: 'Bahasa Indonesia',
    //   key: 'id',
    // },
  ],
  FOR_PRODUCT_COPY: ['ja', 'en', 'cn'],
  CREATE_PRODUCT_LANGUAGE: ['ja'],
  PRODUCT_SERVICE_LANGUAGE: ['ja', 'en', 'cn'],
  PRODUCT_DESIGN: ['ja'],
  PRODUCT_CHATGPT: ['ja'],
  PRODUCT_STABLE_DIFFUSION: ['ja'],
  PRODUCT_LIST_STABLE_DIFFUSION: ['ja', 'en', 'cn'],
  TITLE_LANG: {
    ENTER_EMAIL: {
      ja: i18n.t('page_title.enter_email', 'ja'),
      en: i18n.t('page_title.enter_email', 'en'),
      cn: i18n.t('page_title.enter_email', 'cn'),
    },
    SEND_COMPLETE: {
      ja: i18n.t('page_title.send_complete', 'ja'),
      en: i18n.t('page_title.send_complete', 'en'),
      cn: i18n.t('page_title.send_complete', 'cn'),
    },
    PLAN_ELECTION: {
      ja: i18n.t('page_title.plan_election', 'ja'),
      en: i18n.t('page_title.plan_election', 'en'),
      cn: i18n.t('page_title.plan_election', 'cn'),
    },
    CONFIRM_CONTENT: {
      ja: i18n.t('page_title.confirm_content', 'ja'),
      en: i18n.t('page_title.confirm_content', 'en'),
      cn: i18n.t('page_title.confirm_content', 'cn'),
    },
    REGISTRATION_COMPLETED: {
      ja: i18n.t('page_title.registration_completed', 'ja'),
      en: i18n.t('page_title.registration_completed', 'en'),
      cn: i18n.t('page_title.registration_completed', 'cn'),
    },
    PLAN_UPDATE: {
      ja: i18n.t('page_title.plan_update', 'ja'),
      en: i18n.t('page_title.plan_update', 'en'),
      cn: i18n.t('page_title.plan_update', 'cn'),
    },
    CONFIRMATION_UPDATES: {
      ja: i18n.t('page_title.confirmation_updates', 'ja'),
      en: i18n.t('page_title.confirmation_updates', 'en'),
      cn: i18n.t('page_title.confirmation_updates', 'cn'),
    },
    UPDATE_COMPLETED: {
      ja: i18n.t('page_title.update_completed', 'ja'),
      en: i18n.t('page_title.update_completed', 'en'),
      cn: i18n.t('page_title.update_completed', 'cn'),
    },
    REISSUE_PASSWORD: {
      ja: i18n.t('page_title.reissue_password', 'ja'),
      en: i18n.t('page_title.reissue_password', 'en'),
      cn: i18n.t('page_title.reissue_password', 'cn'),
    },
    SEND_COMPLETED: {
      ja: i18n.t('page_title.send_completed', 'ja'),
      en: i18n.t('page_title.send_completed', 'en'),
      cn: i18n.t('page_title.send_completed', 'cn'),
    },
    PASSWORD_RESET: {
      ja: i18n.t('page_title.password_reset', 'ja'),
      en: i18n.t('page_title.password_reset', 'en'),
      cn: i18n.t('page_title.password_reset', 'cn'),
    },
    PASSWORD_CHANGE_COMPLETED: {
      ja: i18n.t('page_title.password_change_completed', 'ja'),
      en: i18n.t('page_title.password_change_completed', 'en'),
      cn: i18n.t('page_title.password_change_completed', 'cn'),
    },
    NEW_USER_REGISTRATION: {
      ja: i18n.t('page_title.new_user_registration', 'ja'),
      en: i18n.t('page_title.new_user_registration', 'en'),
      cn: i18n.t('page_title.new_user_registration', 'cn'),
    },
    REGISTER: {
      ja: i18n.t('page_title.register', 'ja'),
      en: i18n.t('page_title.register', 'en'),
      cn: i18n.t('page_title.register', 'cn'),
    },
    AI_GI_RESEARCH_REGISTER: {
      ja: i18n.t('page_title.ai_gi_research_register', 'ja'),
      en: i18n.t('page_title.ai_gi_research_register', 'en'),
      cn: i18n.t('page_title.ai_gi_research_register', 'cn'),
    },
    AI_GI_AI_MARKETER: {
      ja: i18n.t('page_title.ai_gi_ai_marketer', 'ja'),
      en: i18n.t('page_title.ai_gi_ai_marketer', 'en'),
      cn: i18n.t('page_title.ai_gi_ai_marketer', 'cn'),
    },
    AI_GI_RESEARCH_REQUEST_RECEIVED: {
      ja: i18n.t('page_title.ai_gi_research_request_received', 'ja'),
      en: i18n.t('page_title.ai_gi_research_request_received', 'en'),
      cn: i18n.t('page_title.ai_gi_research_request_received', 'cn'),
    },
    AI_GI_RESEARCH_RESULT: {
      ja: i18n.t('page_title.ai_gi_research_result', 'ja'),
      en: i18n.t('page_title.ai_gi_research_result', 'en'),
      cn: i18n.t('page_title.ai_gi_research_result', 'cn'),
    },
    PREVIOUS_PROJECTS: {
      ja: i18n.t('page_title.previous_projects', 'ja'),
      en: i18n.t('page_title.previous_projects', 'en'),
      cn: i18n.t('page_title.previous_projects', 'cn'),
    },
    NEW_PROJECT_REGISTRATION: {
      ja: i18n.t('page_title.new_project_registration', 'ja'),
      en: i18n.t('page_title.new_project_registration', 'en'),
      cn: i18n.t('page_title.new_project_registration', 'cn'),
    },
    SEGMENT_SETTING: {
      ja: i18n.t('page_title.segment_setting', 'ja'),
      en: i18n.t('page_title.segment_setting', 'en'),
      cn: i18n.t('page_title.segment_setting', 'cn'),
    },
    MENU_SELECTION: {
      ja: i18n.t('page_title.menu_selection', 'ja'),
      en: i18n.t('page_title.menu_selection', 'en'),
      cn: i18n.t('page_title.menu_selection', 'cn'),
    },
    TASK_SELECTION: {
      ja: i18n.t('page_title.task_selection', 'ja'),
      en: i18n.t('page_title.task_selection', 'en'),
      cn: i18n.t('page_title.task_selection', 'cn'),
    },
    IMAGE_SELECTION: {
      ja: i18n.t('page_title.image_selection', 'ja'),
      en: i18n.t('page_title.image_selection', 'en'),
      cn: i18n.t('page_title.image_selection', 'cn'),
    },
    SELECT_CATEGORY: {
      ja: i18n.t('page_title.category_selection', 'ja'),
      en: i18n.t('page_title.category_selection', 'en'),
      cn: i18n.t('page_title.category_selection', 'cn'),
    },
    SELECT_PRODUCT_COPY: {
      ja: i18n.t('page_title.copyright_setting', 'ja'),
      en: i18n.t('page_title.copyright_setting', 'en'),
      cn: i18n.t('page_title.copyright_setting', 'cn'),
    },
    CONTENT_CONFIRMATION: {
      ja: i18n.t('page_title.content_confirmation', 'ja'),
      en: i18n.t('page_title.content_confirmation', 'en'),
      cn: i18n.t('page_title.content_confirmation', 'cn'),
    },
    INPUT_CONCEPT: {
      ja: i18n.t('page_title.input_concept', 'ja'),
      en: i18n.t('page_title.input_concept', 'en'),
      cn: i18n.t('page_title.input_concept', 'cn'),
    },
    VIEW_RESULTS: {
      ja: i18n.t('page_title.view_results', 'ja'),
      en: i18n.t('page_title.view_results', 'en'),
      cn: i18n.t('page_title.view_results', 'cn'),
    },
    ANALYSIS_RESULTS: {
      ja: i18n.t('page_title.analysis_results', 'ja'),
      en: i18n.t('page_title.analysis_results', 'en'),
      cn: i18n.t('page_title.analysis_results', 'cn'),
    },
    NEW_PROJECT: {
      ja: i18n.t('page_title.new_project', 'ja'),
      en: i18n.t('page_title.new_project', 'en'),
      cn: i18n.t('page_title.new_project', 'cn'),
    },
    SERVICE_SELECTION: {
      ja: i18n.t('page_title.service_selection', 'ja'),
      en: i18n.t('page_title.service_selection', 'en'),
      cn: i18n.t('page_title.service_selection', 'cn'),
    },
    DASHBOARD: {
      ja: i18n.t('page_title.dashboard', 'ja'),
      en: i18n.t('page_title.dashboard', 'en'),
      cn: i18n.t('page_title.dashboard', 'cn'),
    },
    DASHBOARD_PLUG: {
      ja: i18n.t('page_title.dashboard_plug', 'ja'),
      en: i18n.t('page_title.dashboard_plug', 'en'),
      cn: i18n.t('page_title.dashboard_plug', 'cn'),
    },
    LOGIN: {
      ja: i18n.t('page_title.login', 'ja'),
      en: i18n.t('page_title.login', 'en'),
      cn: i18n.t('page_title.login', 'cn'),
    },
    MATERIAL_REQUEST: {
      ja: i18n.t('page_title.material_request', 'ja'),
      en: i18n.t('page_title.material_request', 'en'),
      cn: i18n.t('page_title.material_request', 'cn'),
    },
    MATERIAL_REQUEST_COMPLETE: {
      ja: i18n.t('page_title.material_request_complete', 'ja'),
      en: i18n.t('page_title.material_request_complete', 'en'),
      cn: i18n.t('page_title.material_request_complete', 'cn'),
    },
    GENERATE_PACKAGE_DESIGN: {
      ja: i18n.t('page_title.generate_package_design', 'ja'),
      en: i18n.t('page_title.generate_package_design', 'en'),
      cn: i18n.t('page_title.generate_package_design', 'cn'),
    },
    GENERATE_KEY_VISUAL_SELECT_MENU: {
      ja: i18n.t('survey_project.select_menu_title', 'ja'),
      en: i18n.t('survey_project.select_menu_title', 'en'),
      cn: i18n.t('survey_project.select_menu_title', 'cn'),
    },
    GENERATE_KEY_VISUAL_MESSAGE: {
      ja: i18n.t('generate_screen', 'ja'),
      en: i18n.t('generate_screen', 'en'),
      cn: i18n.t('generate_screen', 'cn'),
    },
    GENERATE_CONCEPT_MESSAGE: {
      ja: i18n.t('generate_concept_screen', 'ja'),
      en: i18n.t('generate_concept_screen', 'en'),
      cn: i18n.t('generate_concept_screen', 'cn'),
    },
  },
  PLAN_SETTING_ALL: 1,
  PLAN_SETTING_ADHOC: 2,
  PLAN_SETTING_OFF: 0,
  MAX_AVG_RADAR_CHART: 2,
  MENU_CHAT: [
    {
      id: 1,
      text: 'ネーミングを生成する',
      textLang: {
        ja: i18n.t('menu_chat.naming', 'ja'),
        en: i18n.t('menu_chat.naming', 'en'),
        cn: i18n.t('menu_chat.naming', 'cn'),
      },
      textResponseLang: {
        ja: i18n.t('chat_result_naming', 'ja'),
        en: i18n.t('chat_result_naming', 'en'),
        cn: i18n.t('chat_result_naming', 'cn'),
      },
    },
    {
      id: 2,
      text: 'キャッチコピーを生成する',
      textLang: {
        ja: i18n.t('menu_chat.catchphrase', 'ja'),
        en: i18n.t('menu_chat.catchphrase', 'en'),
        cn: i18n.t('menu_chat.catchphrase', 'cn'),
      },
      textResponseLang: {
        ja: i18n.t('chat_result_catchphrase', 'ja'),
        en: i18n.t('chat_result_catchphrase', 'en'),
        cn: i18n.t('chat_result_catchphrase', 'cn'),
      },
    },
  ],
  TYPE_NAMING: 1,
  TYPE_CATCHPHRASE: 2,
  TYPE_LAW_PHARMACEUTICAL: 'pharmaceutical',
  TYPE_LAW_MISLEADING_REPRESENTATION: 'misleading_representation',
  CASE_GENERATE_NAMING: [10, 20, 30],
  CASE_GENERATE_CATCHPHRASE: [10, 20, 30],
  RATE_LIMIT_CATCHPHRASE: 3000,

  PLAN_GENERATE_TYPE_MONTH: 1,
  PLAN_GENERATE_TYPE_DAY: 2,
  PLAN_GENERATE_TYPE_ADHOC: 4,
  MAX_IMAGES_PLAN_GENERATE_DAY: 60,

  PLAN_OPTION_TYPE_DAY: 1,
  PLAN_OPTION_TYPE_MONTH: 2,

  PLAN: 'plan',
  PLAN_OPTION: 'plan_option',
  PLAN_GENERATE: 'plan_generate',
  PLAN_KEY_VISUAL: 'plan_key_visual',

  PLAN_GENERATE_FREE_ID: 5, // display JP: お試しプラン (before 2026/06: 無料プラン)
  PLAN_GENERATE_1_DAY_ID: 4,
  PLAN_GENERATE_ADHOC_ID: 6,
  PLAN_GENERATE_UNLIMITED_IDS: [1, 2, 3],
  // Fallback for authUser.retention_time_generate (matches BE IMAGE_RETENTION_DAYS_DEFAULT_GENERATE)
  GENERATION_HISTORY_RETENTION_DAYS_DEFAULT: 35,
  TOKEN_TYPE_REGISTER: 1,
  AUTO_CREATE_ERROR_INFINITY_LOOP: 'infinity loop',
  IS_DEFAULT: 1,

  TARGET_COUNTRY_NONE: 0,
  TARGET_COUNTRY_JP: 1,
  TARGET_COUNTRY_CN: 2,
  TARGET_COUNTRY_TH: 3,
  TARGET_COUNTRY_ID: 4,
  LIST_TARGET_COUNTRY: [
    {
      id: 1,
      text: {
        ja: i18n.t('target_country.ja', 'ja'),
        en: i18n.t('target_country.ja', 'en'),
        cn: i18n.t('target_country.ja', 'cn'),
      },
    },
    {
      id: 2,
      text: {
        ja: i18n.t('target_country.cn', 'ja'),
        en: i18n.t('target_country.cn', 'en'),
        cn: i18n.t('target_country.cn', 'cn'),
      },
    },
    {
      id: 3,
      text: {
        ja: i18n.t('target_country.th', 'ja'),
        en: i18n.t('target_country.th', 'en'),
        cn: i18n.t('target_country.th', 'cn'),
      },
    },
    {
      id: 4,
      text: {
        ja: i18n.t('target_country.id', 'ja'),
        en: i18n.t('target_country.id', 'en'),
        cn: i18n.t('target_country.id', 'cn'),
      },
    },
  ],

  LIST_TARGET_COUNTRY_CONCEPT_VALUATION: [
    {
      id: 1,
      text: {
        ja: i18n.t('target_country.ja', 'ja'),
        en: i18n.t('target_country.ja', 'en'),
        cn: i18n.t('target_country.ja', 'cn'),
      },
    },
  ],

  LIST_TARGET_COUNTRY_AI_GROUP_INTERVIEW: [
    {
      id: 1,
      text: {
        ja: i18n.t('target_country.ja', 'ja'),
        en: i18n.t('target_country.ja', 'en'),
        cn: i18n.t('target_country.ja', 'cn'),
      },
    },
  ],

  CATEGORIES_ALCOHOL: [1, 2, 3, 4, 5, 6],
  CATEGORIES_BEVERAGE: [7, 8, 9, 10, 11, 12, 13, 14, 15],
  CATEGORIES_DESSERTS: [19, 20, 21],
  CATEGORIES_ROOM_TEMPERATURE_FOOD: [22, 23, 25, 26, 27, 28],
  CATEGORIES_CONFECTIONERY: [31, 32, 33, 34, 35],
  CATEGORIES_COSMETICS: [37, 38, 39, 40, 41],
  CATEGORIES_PHARMACEUTICALS: [42, 43],
  CATEGORIES_HYGIENE_PRODUCTS: [45, 46, 47, 48, 49],
  CATEGORIES_PET: [50, 51],
  CATEGORIES_SINGLE: [16, 17, 18, 24, 29, 30, 36, 44, 52, 53, 54, 55, 56, 57],
  CATEGORIES_SINGLE_FOR_REGION_CN: [16, 17, 18, 24, 29, 30, 36, 44, 52, 53, 54, 55, 56],

  CATEGORIES_JP: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
    28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57],
  CATEGORIES_JP_FOR_REGION_CN: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
    28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56],
  CATEGORIES_CN: [1, 2, 7, 9, 10, 15, 16, 17, 18, 19, 20, 25, 29, 30, 31, 34, 36, 37, 38, 39, 41, 45, 47, 48, 49, 50],
  CATEGORIES_TH: [1, 7, 8, 9, 10, 13, 14, 15, 16, 17, 18, 19, 20, 29, 30, 31, 34, 36, 38, 41, 45, 47, 48, 50],
  CATEGORIES_ID: [7, 9, 10, 11, 13, 15, 16, 17, 19, 20, 29, 31, 32, 33, 34, 36, 37, 38, 39, 41, 42, 45, 46, 47, 48, 50],
  COUNTRY_USER_MYPAGE: {
    jp: {
      ja: i18n.t('country_user.ja', 'ja'),
      en: i18n.t('country_user.ja', 'en'),
      cn: i18n.t('country_user.ja', 'cn'),
    },
    cn: {
      ja: i18n.t('country_user.cn', 'ja'),
      en: i18n.t('country_user.cn', 'en'),
      cn: i18n.t('country_user.cn', 'cn'),
    },
    th: {
      ja: i18n.t('country_user.th', 'ja'),
      en: i18n.t('country_user.th', 'en'),
      cn: i18n.t('country_user.th', 'cn'),
    },
    id: {
      ja: i18n.t('country_user.id', 'ja'),
      en: i18n.t('country_user.id', 'en'),
      cn: i18n.t('country_user.id', 'cn'),
    },
    ot: {
      ja: i18n.t('country_user.ot_2', 'ja'),
      en: i18n.t('country_user.ot_2', 'en'),
      cn: i18n.t('country_user.ot_2', 'cn'),
    },
  },

  TYPE_TXT2IMG: 1,
  TYPE_IMG2IMG: 2,
  TYPE_INPAINT: 3,
  TYPE_DELETING: 4,
  TYPE_GENERATE_BRAND: 5,
  TYPE_IMAGES2IMAGE: 6,
  MODEL_PLUG: 'convert_20231220.ckpt',
  MODEL_SDXL: 'sd_xl_base_1.0.safetensors',
  MODEL_DALL_E3: 'dall-e-3',
  MODEL_FLUX_PRO: 'flux-2-pro',
  MODEL_GPT_IMAGE_1: 'gpt-image-1',
  MODEL_GPT_IMAGE_1_5: 'gpt-image-1.5',
  MODEL_GPT_IMAGE_2: 'gpt-image-2',
  MODEL_GPT_IMAGE_2_5_SUNBURST: 'gpt-image-2.5-sunburst',
  MODEL_SD3: 'sd3',
  MODEL_BEER: 'beer_model',
  MODEL_GEMINI: 'gemini 3 pro image',
  MODEL_BEER_FILE_NAME: 'SkillUpAI_beer.safetensors', // File name of the beer model

  GENERATE_IMAGE_MENU_PACKAGE: 1,
  GENERATE_IMAGE_MENU_PRODUCT: 2,
  GENERATE_IMAGE_MENU_KEY_VISUAL: 3,
  GENERATE_IMAGE_MENU_FREE: 4,

  IS_SQUARE_TRUE: 'true', // square
  IS_SQUARE_FALSE: 'false', // landscape
  IS_SQUARE_PORTRAIT: 'portrait',

  MAX_IMAGE_GPT_IMAGE: 2,
  MAX_IMAGE_GEMINI: 6,
  MAX_IMAGE_DELETING: 9,

  LIST_SD_MODEL: [
    {
      key: 'convert_20231220.ckpt',
      text: '日本パッケージデザインモデル',
    },
    {
      key: 'sd_xl_base_1.0.safetensors',
      text: 'SDXL',
    },
  ],
  LIST_MODEL_OPENAI: [
    {
      key: 'gpt-image-2.5-sunburst',
      text: 'GPT Image 2.5 Sunburst',
    },
  ],
  LIST_MODEL_OPENAI_INPAINT: [
    {
      key: 'gpt-image-2',
      text: 'GPT Image 2',
    },
  ],
  LIST_MODEL_SD3: [
    {
      key: 'sd3',
      text: 'SD 3.5 Large',
    },
  ],
  LIST_SD_MODEL_TEXT_TO_IMG: [
    {
      key: 'flux-2-pro',
      text: 'FLUX.2',
    },
  ],
  LIST_MODEL_BEER: [
    {
      key: 'beer_model',
      text: 'ビールモデル',
    },
  ],
  LIST_MODEL_GEMINI: [
    {
      key: 'gemini 3 pro image',
      text: 'Gemini 3 Pro Image [Nano Banana Pro]',
    },
  ],
  MAX_WIDTH_HEIGHT_512: 512,
  MAX_WIDTH_HEIGHT_1024: 1024,

  WIDTH_GPT_IMAGE_1: 1536,
  HEIGHT_GPT_IMAGE_1: 1024,
  WIDTH_FLUX_PRO: 1440,
  HEIGHT_FLUX_PRO: 800,
  WIDTH_GEMINI: 1344,
  HEIGHT_GEMINI: 768,

  MAX_BATCH_SIZE_16: 16,
  MAX_BATCH_SIZE_4: 4,
  MAX_BATCH_SIZE_10: 10,
  MAX_BATCH_SIZE_5: 5,
  NUMBER_SUGGEST_BATCH_SIZE_4: 4,
  NUMBER_SUGGEST_BATCH_SIZE_1: 1,
  STATUS_AMOUNT_CHECKED: 1,
  STATUS_AMOUNT_NO_CHECKED: 0,
  STATUS_MAX_IMAGE_CHECKED: 1,
  STATUS_MAX_IMAGE_NO_CHECKED: 0,
  DATA_HIDDEN: '-',

  REGION_CN: 'cn',
  REGION_JA: 'ja',

  ANALYSIS_IMAGE_FEATURE: 1,
  ANALYSIS_SURVEY: 2,
  ANALYSIS_HEATMAP: 3,
  ANALYSIS_EDIT_DESIGN: 4,
  ANALYSIS_IMAGE_WORDS: 5,
  ANALYSIS_ACCORDING_TO_CONCEPT: 6,
  IMPROVEMENT_IDEAS: 7,
  PRICE_ANALYSIS: 12000,

  MENU_GENERATE_KEY_VISUAL: {
    USAGE_SCENE: 1,
    UPLOAD_PRODUCT: 2,
    BEFORE_AND_AFTER_USE: 3,
    DIFFICULT_SCENE: 4,
    BRAND_WORLD_VIEW: 5,
    MAKE_YOURSELF: 6,
  },

  CONFIRM_SALES: 1,
  CONFIRM_HISTORY_PLAN: 2,
  GRANULARITY_MONTH: 1,
  GRANULARITY_YEAR: 2,
  EXPORT_SALES_BY_PLAN: 1,
  EXPORT_SALES_BY_CLIENT: 2,

  IMG_BASE64_ORIGIN: 1,
  IMG_BASE64_HEATMAP_RESIZE: 2,
  IMG_BASE64_HEATMAP: 3,

  GENERATE_KEY_VISUAL_GPT_IMAGE_1: 'gpt-image-1',
  GENERATE_KEY_VISUAL_FLUX_1_1: 'flux 1.1 pro',
  GENERATE_KEY_VISUAL_GEMINI: 'gemini 3 pro image',

  PRICE_LORA: 30000,

  TYPE_SURVEY_NORMAL: 1,
  TYPE_SURVEY_CALCULATE_ALL: 2,

  TYPE_TEMPORARY_REGISTER: {
    EMAIL_TEMPORARY: 1,
    EMAIL_REGISTERED: 2,
  },

  NOTICE: {
    GENERATE_CONCEPT: 1,
    CHAT_GPT: 2,
    STABLE_DIFFUSION: 3,
    VALUATION_DESIGN: 4,
    VALUATION_SHELVE: 5,
    CONCEPT_EVALUATION: 6,
    AI_GROUP_INTERVIEW: 7,
    NOTICE: 8,
    IMPORTANT: 9
  },
  ALREADY_READ_FORMAT: {
    IMPORTANT_MESSAGE: '1',
    NOTICE_MESSAGE: '2',
  },
  PROMPT_ASSIST: {
    MAX_SIZE_FILE_DOCUMENT: 10 * 1024 * 1024, // 10MB in bytes
    MAX_CONCEPT_LENGTH: 500,
    MODEL: [
      {
        key: 'convert_20231220.ckpt',
        text: 'Stable Diffusion',
      },
      {
        key: 'sd_xl_base_1.0.safetensors',
        text: 'SDXL',
      },
      {
        key: 'dall-e-3',
        text: 'DALL-E3',
      },
      {
        key: 'flux-2-pro',
        text: 'FLUX.2',
      },
      {
        key: 'beer_model',
        text: 'SDXL',
      },
      {
        key: 'gpt-image-2.5-sunburst',
        text: 'GPT Image 2.5 Sunburst',
      },
      {
        key: 'sd3',
        text: 'Stable Diffusion 3.5 large',
      },
      {
        key: 'gemini 3 pro image',
        text: 'Gemini 3 Pro Image [Nano Banana Pro]',
      },
    ],
  },
  AUTO_GENERATE_30: {
    // sync with constant.py AUTO_GENERATE_30_*
    TEST_IMAGE_COUNT: 3,
    REMAINING_IMAGE_COUNT: 27,
    ESTIMATED_MINUTES_PER_JOB: 30,
    REFERENCE_IMAGE_MAX_SIZE: 4 * 1024 * 1024,
    REFERENCE_IMAGE_EXTENSIONS: ['jpg', 'jpeg', 'png'],
    REFERENCE_IMAGE_MIME_TYPES: ['image/jpeg', 'image/png'],
    DOCUMENT_MAX_SIZE: 10 * 1024 * 1024,
    DOCUMENT_EXTENSIONS: ['pdf', 'ppt', 'pptx', 'xls', 'xlsx'],
    DOCUMENT_MIME_TYPES: [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'application/vnd.ms-powerpoint',
    ],
  },
  GENERATE_CONCEPT: {
    MODEL: ['GPT-5.5', 'Gemini 3.5 Flash', 'Claude 4.6 Sonnet'],
  },

  RECAPTCHA_ENDPOINT: 'https://www.google.com/recaptcha/api.js',

  TYPE_EXPORT_PDF: {
    OVER_ALL: 'over_all',
    HEATMAP: 'heatmap',
    IMAGE_WORD_LINE: 'image_word_line',
    IMAGE_WORD_SCATTER: 'image_word_scatter',
    VARIANCE: 'variance',
    CONCEPT_MATCHING: 'concept_matching',
    ANALYSIS: 'analysis',
    SHELVE: 'shelve',
  },
  // sync with constant.py ALLOWED_FILE_DOCUMENT_TYPES
  ALLOWED_FILE_DOCUMENT_TYPES: [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ],

  MFA_ENABLE: 1,
  MFA_DISABLE: 0,

  TRUSTED_IP_ENABLE: 1,
  TRUSTED_IP_DISABLE: 0,

  DISABLED_MODEL_FLUX_ENABLE: 1,
  DISABLED_MODEL_FLUX_DISABLE: 0,

  GEN_PROMPT_REF_MAX_LENGTH: 15000,

  CONCEPT_VALUATION_MAX_LENGTH: 3000,
  CONCEPT_VALUATION_SUMMARIZE_MIN_LENGTH: 500,
  CONCEPT_VALUATION_SLOT_COUNT: 5,

  // sync with constant.py AI_GI_ESTIMATED_MINUTES_PER_JOB / AI_GI_STATUS_*
  AI_GI_ESTIMATED_MINUTES_PER_JOB: 90,
  AI_GI_PROGRESS_POLL_INTERVAL_MS: 5000,
  AI_GI_STATUS_QUEUED: 1,
  AI_GI_STATUS_PROCESSING: 2,
  AI_GI_STATUS_SUCCESS: 3,
  AI_GI_STATUS_ERROR: 4,
  AI_GI_STATUS_TIMEOUT: 5,

  // Generation history API (matches BE PROJECT_* / GENERATION_HISTORY_*)
  PROJECT_CHAT_GPT: 9,
  PROJECT_GENERATE_IMAGE: 10,
  PROJECT_GENERATE_CONCEPT: 12,

  GENERATION_HISTORY_FILTER_ALL: 1,
  GENERATION_HISTORY_FILTER_KEYWORD: 2,
  GENERATION_HISTORY_FILTER_RECENT_30D: 3,
  GENERATION_HISTORY_FILTER_TODAY: 4,
  GENERATION_HISTORY_FILTER_THIS_WEEK: 5,
  GENERATION_HISTORY_FILTER_THIS_MONTH: 6,
  GENERATION_HISTORY_KEYWORD_MAX_LENGTH: 100,

  GENERATION_HISTORY_FAVORITE_ITEM_CONCEPT: 1,
  GENERATION_HISTORY_FAVORITE_ITEM_NAMING: 2,
  GENERATION_HISTORY_FAVORITE_ITEM_CATCHCOPY: 3,
  GENERATION_HISTORY_FAVORITE_ITEM_DESIGN: 4,
  GENERATION_HISTORY_FAVORITE_ITEM_EDIT_CONCEPT: 5,

  // Concept/edit text ★ (not a poster). 255 avoids 0..MAX-1 and PositiveSmallIntegerField.
  GENERATION_HISTORY_FAVORITE_POSTER_INDEX_TEXT: 255,
  // Keep in sync with apps/pdr/constant.py CONCEPT_POSTER_MAX_IMAGES.
  CONCEPT_POSTER_MAX_IMAGES: 2,

  isOpenAiGptImageModel(modelKey) {
    return (
      modelKey === this.MODEL_GPT_IMAGE_2
      || modelKey === this.MODEL_GPT_IMAGE_2_5_SUNBURST
    );
  },
  // Keep in sync with apps/pdr/constant.py RESEARCH_AVATAR_AI_RESPONSE_TIMEOUT_MS (spec §7.7 = 60s)
  RESEARCH_AVATAR_AI_RESPONSE_TIMEOUT_MS: 60000,

};
